module.exports = __webpack_public_path__ + "static/media/garage_selected.5f431430.svg";